import { useState } from "react";
import type { TableColumnType } from "antd";
import { Table } from "antd";
import { MdInventory } from "react-icons/md";
import type { LinhaRelatorioEstoque } from "./types";
import { formatNumeroPtBr } from "./format";
import {
  EstoqueButton,
  BadgeCount,
  StyledEstoqueModal,
  Title,
  ButtonStyledLink,
} from "./styles";

interface ConsultarEstoqueButtonProps {
  countNegativos: number;
  linhas: LinhaRelatorioEstoque[];
  isLoading?: boolean;
}

function getColumns(): TableColumnType<LinhaRelatorioEstoque>[] {
  return [
    {
      title: "Insumo",
      dataIndex: "insumoLabel",
      key: "insumoLabel",
      render: (value: string) => <span className="insumo-cell">{value}</span>,
    },
    {
      title: "Estoque Fazenda",
      dataIndex: "estoqueFazenda",
      key: "estoqueFazenda",
      align: "center",
      render: (v: number) => formatNumeroPtBr(v),
    },
    {
      title: "Fator embalagem",
      dataIndex: "fatorEmbalagem",
      key: "fatorEmbalagem",
      align: "center",
      render: (v: number) => formatNumeroPtBr(v),
    },
    {
      title: "Programado em O.S. Anteriores",
      dataIndex: "programadoEmOs",
      key: "programadoEmOs",
      align: "center",
      render: (v: number) => formatNumeroPtBr(v),
    },
    {
      title: "Programado nesta O.S.",
      dataIndex: "programadoNestaOs",
      key: "programadoNestaOs",
      align: "center",
      render: (v: number) => formatNumeroPtBr(v),
    },
    {
      title: "Previsão de Estoque",
      dataIndex: "previsaoEstoque",
      key: "previsaoEstoque",
      align: "center",
      render: (v: number, record) => (
        <span className={record.temAlerta ? "prev-negativa" : undefined}>
          {formatNumeroPtBr(v)}
        </span>
      ),
    },
  ];
}

export function ConsultarEstoqueButton({
  countNegativos,
  linhas,
  isLoading,
}: ConsultarEstoqueButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <EstoqueButton size="large" onClick={() => setOpen(true)} loading={isLoading}>
        <MdInventory size={18} />
        Consultar Estoque
        {countNegativos > 0 && <BadgeCount>{countNegativos}</BadgeCount>}
      </EstoqueButton>

      <StyledEstoqueModal
        centered
        visible={open}
        onCancel={() => setOpen(false)}
        width="min(1280px, 96vw)"
        zIndex={1000000}
        destroyOnClose
        title={
          <Title>
            <MdInventory color="#fff" size={28} />
            Consultar Estoque de Insumos - O.S.
          </Title>
        }
        footer={
          <ButtonStyledLink size="large" onClick={() => setOpen(false)}>
            Fechar
          </ButtonStyledLink>
        }
      >
        <Table
          columns={getColumns()}
          dataSource={linhas}
          rowKey="insumoId"
          pagination={false}
          loading={isLoading}
          scroll={{ x: true }}
          rowClassName={record => (record.temAlerta ? "row-alerta" : "")}
        />
      </StyledEstoqueModal>
    </>
  );
}
